const ActionItemFilterData = ({ ownedCount, assignedCount, releasedCount, archivedCount, reassignCount, totalOwnedOrAssignedCount }) => {

  return [
    { value: "all", label: <>List All Task Items <span style={{ display: "inline-flex", alignItems: "center", gap: "4px", marginLeft: "6px" }}>
      {/* <span style={{ background: "red", color: "#fff", borderRadius: "10px", padding: "0px 8px", fontSize: "0.78em", fontWeight: 600 }}>{totalOwnedOrAssignedCount}</span> */}
      {/* <span style={{ background: "#0D6EFD", color: "#fff", borderRadius: "10px", padding: "0px 8px", fontSize: "0.78em", fontWeight: 600 }}>{releasedCount + archivedCount + reassignCount}</span> */}
      </span>
      </> },
    { value: `&owned_by=${localStorage.getItem("user_id")}`, label: <>List <span style={{ color: "default" }}>{ownedCount} Tasks</span>  Owned by You</> },
    { value: `&assign_to=${localStorage.getItem("user_id")}`, label: <>List <span style={{ color: "default" }}>{assignedCount} Tasks</span>  Assigned to You</> },
    { value: `&is_reassigned=true`, label: <>List <span style={{ color: "#0D6EFD" }}>{reassignCount} Tasks</span>  To Be Reassigned</> },
    {
      value: "&is_released=true",
      label: <>List <span style={{ color: "#0D6EFD" }}>{releasedCount} Released Procedures</span>  To Create New Rev for System to Update</>,
    },
    {
      value: "&is_archived=true",
      label: <>List <span style={{ color: "#0D6EFD" }}>{archivedCount} Archived Procedures</span>  To Create New Rev for System to Update</>,
    },
  ]
}
export default ActionItemFilterData;

